import { Component, OnInit, ViewChild } from "@angular/core";
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { Rest } from "../../../../../../rest/rest_client";
import { AuthenticationService } from "../../../../../../core/services/authentication/authentication.service";
import { I18nService } from "../../../../../../services/i18n/i18n.service";
import { NotificationsService } from "../../../../../../services/notifications-service/notifications.service";
import { RestExt } from "../../../../../../services/rest-client-extension";
import { EntityListComponent } from "../../../../../../components/entity-list/entity-list.component";
import { CostCentreFormComponent } from '../cost-centre-form/cost-centre-form.component';
import { CecoService } from "app/rest/ceco.service";
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";

@Component({
    selector: 'app-cost-centre-list',
    templateUrl: './cost-centre-list.component.html',
    styleUrls: ['./cost-centre-list.component.css'],
    providers: [CecoService, ConfirmationService, UserTimePipe, ExcelService],
    standalone: false
})
export class CostCentreListComponent
    extends EntityListComponent<Rest.Ceco>
    implements OnInit {
    title: string = this.translateService.instant('navbar.clients');

    @ViewChild(CostCentreFormComponent, { static: true })
    editForms: CostCentreFormComponent;

    disableSave: boolean;

    user: Rest.User;
    EnabledFilter: SelectItem[];

    constructor(
        private cecoService: CecoService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService
    ) {
        super(
            cecoService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
        this.cecoService = cecoService;
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.editForms;
        this.hasEntityFilters = false;
        /*Permissions */
        this.user = this.authenticationService.user;
        /** */
    }

    protected beforeLoad() {
         if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
            this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
    }

    afterLoad() {
        // this.EnabledFilter = RestExt.getEnabledFilter(
        //     this.filters["enabled"],
        //     this.i18n
        // );
        // this.paginationResult.entities.forEach((cl: any) => {
        //     /*Permissions */
        //     cl._$changeStatus = true; //This is for the validation of entity-list (selectAll function)
        //     cl._$update = true;
        //     /** */
        // });
        // /*Permissions */
        // this.checkSelectAll();
        /** */
    }
    excelColumns = {};
    exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translateService.instant('tableManagement.costCentres.costCentresManagement');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
        const code = (entity: any) => entity.code ?? ''
        const description = (entity: any) => entity.description ?? ''
        const disabled = (entity: any) => entity.disabled ?? ''
        const company = (entity: any) => entity.billingAccount.name ?? ''
        this.excelColumns = {
            [this.translateService.instant('general.code')]: { bindField: code },
            [this.translateService.instant('promotedRoutes.description')]: { bindField: description },
            [this.translateService.instant('drivers.table.company')]: { bindField: company },
            [this.translateService.instant('general.disabled')]: { bindField: disabled },
        }
    }
}
